import { apiJson } from './httpClient';
import { getApiBase } from './getApiBase';

export type AdobeSessionUser = {
  sub: string | null;
  name: string;
  givenName: string | null;
  familyName: string | null;
  email: string | null;
  emailVerified: boolean;
  accountType: string | null;
  addressCountry: string | null;
};

export type AdobeSessionResponse =
  | { authenticated: false }
  | {
      authenticated: true;
      user: AdobeSessionUser;
      expiresAt: number;
    };

export async function getAdobeSession(): Promise<AdobeSessionResponse> {
  return apiJson<AdobeSessionResponse>('/me');
}

export function startAdobeLogin(): void {
  window.location.assign(`${getApiBase()}/auth/adobe`);
}

export async function logoutAdobeSession(): Promise<string> {
  const res = await fetch(`${getApiBase()}/auth/logout`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json'
    }
  });

  const text = await res.text();
  let payload: { redirectTo?: string } | null = null;
  if (text) {
    try {
      payload = JSON.parse(text);
    } catch {
      payload = null;
    }
  }

  if (!res.ok) {
    throw new Error(payload?.redirectTo ? `Logout failed, redirecting to ${payload.redirectTo}` : 'Logout failed');
  }

  return payload?.redirectTo || window.location.origin;
}
